/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Schema para la respuesta al crear un usuario con éxito.
 */
export interface UserCreateResponse { 
    message?: string;
    user_id: string;
}

